export default "__VITE_ASSET__bc0d87dd__"